import React from 'react';
import {get} from '../Storage';
import PropTypes from 'prop-types';
import axios from 'axios';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'CashOutComponent';
var styles = AppSettings.styles;


class Cashout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            amount: "-",
            isSelected: 'no',
            proactiveCashoutData: props.proactiveCashoutData,
            showModal: false,
            modalMessage: '',
            disabledCta:false,
            feedback:false,
        }
        this.configuration = props.configuration;
        this.timeoutSecond = this.configuration.timeoutAskCashout;
        this.cashoutAskTimeout = new Map();
        this.handleAskCashOut = this.handleAskCashOut.bind(this);
        this.handleDoCashOut = this.handleDoCashOut.bind(this);
        this.radioChangeHandler = this.radioChangeHandler.bind(this);
    }

    isProcessing = false;

    componentDidUpdate(prevProps) {
        if ((this.configuration.cashoutProattivoEnabled && this.props.proactiveCashoutData !== undefined) 
            && (prevProps.proactiveCashoutData !== this.props.proactiveCashoutData)) {
            this.setState({ amount: this.props.proactiveCashoutData.amount, proactiveCashoutData: this.props.proactiveCashoutData });
        }
    }

    formatCurrency(value, locale = 'it-IT', currency = 'EUR') {
        return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        }).format(value);
    }
    //Radio button check 
    radioChangeHandler(e){
        this.setState({
            isSelected: e.target.value
        });
    }
   
    // GET ASK CASHOUT 
    handleAskCashOut(event){
        event.stopPropagation();
        event.preventDefault();

        if (this.isProcessing) return;
        this.isProcessing = true;

        var self = this;
        let ticketId = self.props.data.betId;
        let element = event .currentTarget; 

        // aggiungo la classe sul click 
        element.classList.add('cashout-btn-loading');
        // check richieste consecutive
        if(self.cashoutAskTimeout.has(ticketId)){
            let expireDate = new Date();
            let expireTimeout = self.cashoutAskTimeout.get(ticketId);
            if (expireTimeout > expireDate) {
                setTimeout(() => {
                    element.classList.remove('cashout-btn-loading');
                }, 300);

                self.props.onClick(this.state.data);
                return;
            }
            self.cashoutAskTimeout.delete(ticketId);
        }

        var url = AppSettings['env'].urlCashOutAsk.replace('[TicketId]', ticketId);
        axios.get(url)
            .then(({ data, status, statusText }) => {
                data.do = false;
                if (!this.configuration.cashoutProattivoEnabled) {
                    data.ask = true;

                    //check richieste consecutive
                    let expireDate = new Date();
                    let nowSeconds = expireDate.getSeconds();
                    expireDate.setSeconds(nowSeconds + self.timeoutSecond);
                    if (self.cashoutAskTimeout.has(data.ticketId)) {
                        self.cashoutAskTimeout.delete(data.ticketId);
                    }
                    element.classList.remove('cashout-btn-loading');
                    self.cashoutAskTimeout.set(data.ticketId, expireDate);

                    if (data.errors.length == 0) {
                        this.setState({
                            amount: data.amount,
                            id: data.id,
                            betId: data.ticketId,
                            data: data
                        });
                    }
                    else {
                        data.ticketId = self.props.data.betId;
                        this.setState({
                            userMessage: data.errors[0].userMessage,
                            code: data.errors[0].code,
                            amount: "-",
                            data: data
                        });

                    }
                } else {
                    const ctaCashout = document.querySelector(".cash-out-btn-check.cash-out-on.cashout-btn-loading");
                    ctaCashout.classList.remove('cashout-btn-loading');
                    ctaCashout.classList.add('cashout-disabled');
                    if (data.errors.length == 0) {
                        this.setState({
                            amount: data.amount,
                            id: data.id,
                            betId: data.ticketId,
                            data: data
                        })

                        if (data.amount >= self.state.amount) {
                            this.handleDoCashOut(event);
                        } else {
                            this.setState({ showModal: true, modalMessage: "Il valore del cashout è cambiato", disabledCta: true });
                            setTimeout(() => {
                                this.setState({ showModal: false, modalMessage: "", disabledCta: false });
                            }, 3000);
                        }
                    }
                }
                
                self.props.onClick(data);

            })
            .catch((error) => {
                this.setState({
                    error: true,
                    userMessage: "",
                    code: "",
                    amount: "-"
                });

                element.classList.remove('cashout-btn-loading');

                let response = {
                    do: false,
                    ask: true,
                    ticketId: self.props.data.betId,
                    errors: [
                        {
                            "code": 200,
                            "internalMessage": "Error catch ASK",
                            "moreInfo": null,
                            "userMessage": "Si è verificato un errore inaspettato"
                        }]
                }
                self.props.onClick(response);
                
            }).finally(() => {
                this.isProcessing = false;
            })
            
    }

    renderMessageCashOut(){
        if (!this.state.showModal) {
            return;
        }

        return (
            <div className={`proactive-cash-out-info-amount ${this.state.feedback ? "feedback-cashout": ""}`}>
                <p>{this.state.modalMessage}</p>
            </div>
        );
     }

    //POST DO CASHOUT
    handleDoCashOut(event){
        event.stopPropagation();
        event.preventDefault();

        var self = this;
        let force = this.state.isSelected === 'si';
        let ticket = this.props.data;
        let amount = ticket.amount;

        if(this.configuration.cashoutProattivoEnabled){
            force = true;
            amount = this.state.amount;
        }

        let request = {
            request:{
                TicketId: ticket.ticketId, 
                // TicketId: 222, 
                SessionToken: "",
                Force: force,
                Id: ticket.id, 
                ClientAmount: amount,
            }
        };
        let headers = {
            'Content-Type': 'application/json'
        };

        var url = AppSettings['env'].urlCashOutDo;

        axios.post(url, request, headers)
            .then(({ data, status, statusText }) => {
               
                data.ask = false;
                data.do = true;
                data.ticketId = ticket.ticketId;
                self.props.onClick(data);

                 if(this.configuration.cashoutProattivoEnabled){
                    this.setState({ showModal: true, modalMessage: "", disabledCta: true, feedback: true });
                }
            })
            .catch(({ data }) => {
                let response = {
                    do: true,
                    ask: false,
                    ticketId: ticket.ticketId,
                    errors: [
                        {
                            "code": 200,
                            "internalMessage": "Error catch DO",
                            "moreInfo": null,
                            "userMessage": "Il Cashout non è applicabile al ticket"
                        }]
                };

                self.props.onClick(response);  

            })
    }

    
    //1. CASHOUT 
    renderButton() {
        
        return (
            <div className={`cash-out-check-container`}>
                {!this.configuration.cashoutProattivoEnabled ?
                    <>
                        <a onClick={this.handleAskCashOut} className="cash-out-btn-check cash-out-on">
                            <span className="cash-out-lbl">Verifica</span>
                            <i></i>
                        </a>
                        <a className="cash-out-btn cash-out-btn-toggle" href="#" >
                            <span className="cash-out-amount">{this.state.amount}</span>
                            <span className="cash-out-lbl">Cashout</span>
                            <i></i>
                        </a>
                    </>
                    : <>
                        {(this.props.proactiveCashoutData && this.props.proactiveCashoutData.amount) && 
                        <a 
                        onClick={this.handleAskCashOut} 
                        className={`cash-out-btn-check cash-out-on proactive-cashout-cta ${this.state.disabledCta ? 'mg-disabled' : ''}`}>
                            <span className="cash-out-lbl">Cashout {this.formatCurrency(this.props.proactiveCashoutData.amount)}</span>
                        </a>}
                    </>}
            </div>
        );
    }

    //2. ASK SUCCESS
     renderCashOutInfo(){
           return(
                <div className="cash-out-info cash-out-toggle">
                    <div className="mg-accetta-variazione-container" >
                        <div className="content-selection">
                            <div className="mg-accetta-variazione-toggle"> 
                                <p>Accetto variazione importo</p><a href="#"></a>
                            </div>
                            <div className="mg-accetta-variazione-switch">
                               <input type="radio" id="cashoutAcceptChangeAmountYes" label="Si" value="si" checked={this.state.isSelected === "si"} onChange={this.radioChangeHandler} />
                               <label htmlFor="cashoutAcceptChangeAmountYes">Si</label>
                               <input type="radio" id="cashoutAcceptChangeAmountNo" label="No" value="no" checked={this.state.isSelected === "no"} onChange={this.radioChangeHandler} />
                               <label htmlFor="cashoutAcceptChangeAmountNo">No</label>
                            </div>
                        </div>
                    </div>
                    <a onClick={this.handleDoCashOut} className="cashout-do-btn">Conferma Cashout</a>
                </div>
            );
     }


     //Gestione errore 
    renderCashOutError() {
        const { userMessage } = this.props.data.errors[0];

        return (
            <div className="cashout-do-error">
                {userMessage}
            </div>
        );
    }
    //3. Accettato cashOut
    renderCashOutConfirm(){
        return (
            <span className="bs-ticket-info-value bs-cashout">
                <span className="resultSuccess">Cashout Confermato</span>
            </span>
        );
    }

    //render
    render() {

        //DEFAULT
        if (this.props.type == "button") {

            return (
                <>
                    {(!this.state.showModal && this.props.type == "button" && !this.props.hideCta) && this.renderButton()}
                    {this.state.showModal && this.renderMessageCashOut()}
                </>
            );
        }

        //ASK REQUEST 
        if (this.props.type == "confirm") {
            return this.renderCashOutInfo();
        }

        //DO SUCCESS
        if (this.props.type == "success") {
            return this.renderCashOutConfirm();
        }

        //Error
        if (this.props.type == "error") {

            return this.renderCashOutError();
        }
    }



}

Cashout.displayName = componentName;

Cashout.propTypes = {
     data: PropTypes.object.isRequired,
     onClick: PropTypes.func,
     type: PropTypes.string
};

// default props
Cashout.defaultProps = {
    type: "button"
};

export default Cashout;